import React from 'react'
import { connect } from 'react-redux'
import ReactDependentScript from 'react-dependent-script'
import Configurator from '../../configurator'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import {
    setOnBoardingPlaceAction,
    setOnBoardingStepAction,
} from '../../admin/actions/on-boarding'
import inOnBoarding, {
    ON_BOARDING_STEP_CITY,
    ON_BOARDING_STEP_BIRTHDAY, ON_BOARDING_STEP_SPORT,
} from './hoc'
import { AutocompleteRaw } from '../../admin/components/shared/location-helper'
import Loader from '../../front/components/shared/loader'
import { storeLocation } from './actions'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_CITY)
class PlaceOnBoarding extends Configurator {

    state = {
        loaded: false,
        placeName: null,
    }

    componentDidMount() {
        this.updateLocationFromStore()

        if (!this.props.userSport) {
            setOnBoardingStepAction(ON_BOARDING_STEP_SPORT)
        }
    }

    componentDidUpdate = () => {
        this.updateLocationFromStore()
    }

    /**
     * Update location into input from store
     */
    updateLocationFromStore = () => {
        const { place } = this.props
        const { loaded } = this.state

        if (!loaded && place) {
            this.setState({
                loaded: true,
                placeName: place.formatted_address,
            })
        }
    }

    /**
     * Go to next step
     */
    gotoNextStep = () => {
        const {
            place,
            user,
            userSport,
        } = this.props

        const storeData = {
            ...place,
            user_sport_id: userSport.id,
        }

        return storeLocation(storeData, user.slug)
            .then(() => setOnBoardingStepAction(ON_BOARDING_STEP_BIRTHDAY))
    }

    /**
     * Set user place (city) into store
     * @param {Object} place
     */
    setUserPlace = place => {
        if (place && place.geometry) {
            const location = {
                name: place.name,
                formatted_address: place.formatted_address,
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
            }

            setOnBoardingPlaceAction(location)
            this.setState({ placeName: place.formatted_address })
        }
    }

    /**
     * Save typed place name into state
     * @param {Object} e
     */
    onPlaceValueChanged = e => {
        this.setState({ placeName: e.target.value })
    }

    render = () => {
        const {
            place,
            t,
        } = this.props

        const { placeName } = this.state

        const { REACT_APP_GOOGLE_MAPS_API_KEY } = this.config

        return (
            <div className="d-flex flex-column">
                <span className="text-color-gray-dark-2 font-weight-bold font-size-xl mb-2">{t('onBoardingPlaceTitle')}</span>
                <span className="text-color-gray-dark-1 font-size-md mb-2">{t('onBoardingPlaceSubtitle')}</span>
                <ReactDependentScript
                    loadingComponent={<Loader />}
                    scripts={[`https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`]}
                >
                    <AutocompleteRaw
                        className="form-control d-block col-12 col-md-8"
                        locationTypes={['(cities)']}
                        onPlaceSelected={this.setUserPlace}
                        placeholder={t('onBoardingPlaceInputPlaceholder')}
                        value={placeName}
                        onChange={this.onPlaceValueChanged}
                    />
                </ReactDependentScript>
                <div className="d-flex justify-content-end mt-4">
                    <Button
                        className="btn btn-color-brand btn-circle"
                        onClick={this.gotoNextStep}
                        disabled={!place}
                    >
                        {t('next')}
                    </Button>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    place: state.onBoarding.userData.place,
    userSport: state.onBoarding.userSport,
}))(PlaceOnBoarding)
